var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-container mr-2"},[_c('div',{staticClass:"center con-switch"},[_c('vs-switch',{staticClass:"vs-switch-success",on:{"click":_vm.ChangeStatus},model:{value:(_vm.actiobBtn),callback:function ($$v) {_vm.actiobBtn=$$v},expression:"actiobBtn"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }